export const PARTNER_ROUTES = {
  DASHBOARD: '/assessments/dashboard',
  ANALYSTS: '/assessments/analysts',
  ANALYSTS_VIEW: '/assessments/analysts/:analystId',
  ASSESSMENTS_VIEW: '/assessments/:id/results',
  PEOPLE: '/assessments/people',
  CERTIFICATES: '/assessments/certificates',
  COURSE_CERTIFICATES: '/assessments/course-certificates',
  INTEGRATIONS: '/assessments/integrations',
  TEAM: '/assessments/team',
  PROFILE: '/assessments/account',
  INVOICES: '/assessments/invoices',

  UNIVERSITY: '/university/dashboard',
  UNIVERSITY_COURSES: '/university/courses',
  UNIVERSITY_CERTIFICATES: '/university/certificates',
  UNIVERSITY_COURSES_VIEW: '/university/courses/:courseId',
  UNIVERSITY_COURSES_CONTENT: '/university/courses/:courseId/content/:contentId',
  UNIVERSITY_COURSES_ENROLL: '/university/courses/:courseId/enroll',
  UNIVERSITY_COURSES_UNENROLL: '/university/courses/:courseId/unenroll',
  UNIVERSITY_COURSE_ENROLLMENT: '/university/courses/:courseId/enrollment',
  STUDENT_DASHBOARD: '/university/dashboard',

  // Fallback
  NOT_FOUND: '*',
} as const;